module.exports = __webpack_public_path__ + "static/img/ban-4.d22bd3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-4.png
// module id = aur5
// module chunks = 0